import { Nature, Section } from '@mairistem/comptabilite';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import BaseProfilEcritureRecette from './Base/BaseProfilEcritureRecette';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';
import CovidPanel from '../panel/CovidPanel';
import DetailDeFacturationPanel from '../panel/DetailDeFacturationPanel';
import EditionAsapDematerialiseePanel from '../panel/EditionAsapDematerialiseePanel';
import ProjetPanel from '../panel/ProjetPanel';

class ProfilEcritureOrdInvSansInventRecette extends BaseProfilEcritureRecette {
  constructor() {
    super();
    this.code = PROFIL_ECRITURE.RECETTE.ORD_INV_SANS_INVENT;
    this.typeBordereau = TYPE_BORDEREAU.RECETTE.ORDINAIRE;
    this.naturePiece = NATURE_PIECE.RECETTE.INVESTISSEMENT;
    this.typePiece = TYPE_PIECE.RECETTE.ORDINAIRE;
    this.imputation.nature = Nature.REEL;
    this.imputation.section = Section.INVESTISSEMENT;
    this.panels = [
      ...this.panels,
      new CompteDeTiersPanel(),
      new CovidPanel(),
      new DetailDeFacturationPanel(),
      new EditionAsapDematerialiseePanel(),
      new ProjetPanel(),
    ];
  }
}

export default ProfilEcritureOrdInvSansInventRecette;
